<template>
  <v-dialog max-width="800" v-model="dialog" @click:outside="hide">
    <v-card>
      <v-card-title class="text-h6">{{ $t("text.order_service") }}</v-card-title>

      <v-card-text>
        <v-autocomplete v-if="!hideSearch" v-model="value" :items="availableMachines" item-title="DisplayName"
          item-value="Id" return-object chips closable-chips clearable :label="$t('text.search_machine')"
          prepend-inner-icon="mdi-magnify" variant="outlined" density="comfortable" hide-details
          :menu-props="{ maxHeight: 360 }" />
      </v-card-text>

      <v-card-text v-if="value">
        <v-list density="compact" class="pa-0 bg-transparent">
          <MachineListItem :item="value" />
        </v-list>
        <v-textarea v-model="value.CustomerText" class="mt-3" variant="outlined" rows="4" auto-grow
          :label="$t('text.error_description') + ' (' + $t('text.required') + ')'" />
      </v-card-text>

      <v-card-actions>
        <v-btn variant="text" :disabled="isInAsync" @click="hide">
          {{ $t("text.close") }}
        </v-btn>
        <v-spacer />
        <v-btn color="primary" variant="flat" :disabled="!isValid || isInAsync || !value" :loading="isInAsync"
          @click="createJob">
          {{ $t("text.order_now") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import http from "@/api/client";
import MachineListItem from "@/components/ListItems/MachineListItem.vue";

export default {
  name: "NewJobDialog",
  props: {
    machine: {
      type: String,
      default() {
        return null;
      },
    },
    machines: {
      type: Array,
      default() {
        return null;
      },
    },
  },
  components: {
    MachineListItem,
  },

  data() {
    return {
      hideSearch: false,
      isInAsync: false,
      availableMachines: [],
      dialog: true,
      value: null,
    };
  },

  created() {
    if (!this.machines) {
      http()
        .get("api2/customer/machines")
        .then((response) => {
          this.availableMachines = response.data || [];
          this.applySingleMachinePreset();
        });
    } else {
      this.availableMachines = this.machines || [];
      this.applySingleMachinePreset();
    }
  },

  methods: {
    applySingleMachinePreset() {
      if (this.machine != null && this.machine !== "" && this.availableMachines.length === 1) {
        this.value = this.availableMachines[0];
        this.hideSearch = true;
      }
    },

    createJob() {
      this.isInAsync = true;
      http()
        .post("api2/customer/jobs", {
          Machines: [this.value],
        })
        .then((result) => {
          const id = result.data.Id;
          this.$emit("exit", id);
        })
        .catch(() => {
          /* keep dialog open; parent may show errors later */
        })
        .finally(() => {
          this.isInAsync = false;
        });
    },

    hide() {
      this.$emit("exit");
    },
  },

  computed: {
    isValid() {
      return Boolean(this.value?.CustomerText?.trim());
    },
  },
};
</script>
